import React from 'react';
import { Helmet } from 'react-helmet-async';

interface RobotsProps {
  /**
   * nofollow = Don't crawl the links on this page
   * noindex = Don't include this page in search results
   * none =
   *  - Don't crawl the links on this page
   *  - Don't include this page in search results
   * More details: https://developers.google.com/search/reference/robots_meta_tag
   */
  mode: 'index, nofollow' | 'noindex, follow' | 'none';
}

const Robots = ({ mode }: RobotsProps) => (
  <Helmet>
    <meta content={mode} name="robots" />
  </Helmet>
);

export { Robots };
